import React, { useEffect, useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { BASE_URL, BASE_IMAGE_URL } from "../../service/apiConfig";
import Highlighter from "react-highlight-words";
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import {
  Select,
  Typography,
  DatePicker,
  Space,
  Button,
  Table,
  Modal,
  Row,
  Col,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  Checkbox,
  Radio,
} from "antd";
import moment from "moment";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import countriesApi from "../../service/countriesApi";
import locationTourApi from "../../service/locationTourService";
import translateApi from "../../service/translateService";
import "./management.css";
import MapManagement from "./MapManagement";
import { useSelector } from "react-redux";
import adminService from "../../service/adminService";


const Search = Input.Search;
const { Option } = Select;
export default function ManagementPage() {

  const deepEqual = isEqual;
  const currentLocation = useSelector((state) => state.currentLocation);

  const [language, setLanguage] = useState("vi");
  const [tourData, setTourData] = useState();

  const [centerMap, setCenterMap] = useState({
    latitude: "",
    longitude: "",
  });
  const [province, setProvince] = useState([]);

  const [tourId, setTourId] = useState(0);

  const [isShowUpdateTour, setIsShowUpdateTour] = useState(false);

  const [listLocationTour, setListLocationTour] = useState([]);

  const [listCountry, setListCountry] = useState([]);

  const [dataLocationTour, setDataLocationTour] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [fileListSubmit, setFileListSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingTranslate, setLoadingTranslate] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [dataTranslate, setDataTranslate] = useState();
  const [titleData, setTitleData] = useState("");
  const [desData, setDesData] = useState("");
  const [dataChange, setDataChange] = useState(true);
  const [lastData, setLastData] = useState({});
  const [onRegisterAds, setOnRegisterAds] = useState(false);
  const [sendNotification, setSendNotification] = useState(false);
  
  const [isShowAds,  setIsShowAds] = useState(false);
  const [isCustomer,  setIsCustomerAds] = useState(false);
  const [filterOnChange, setFilterOnChange] = useState(false);


  const [form] = Form.useForm();
 
  useEffect(() => {
    getAllTour();    
  }, [filterOnChange]);

  useEffect(() => {
    const date = new Date()
    form.setFieldsValue({
      dateTimeOpen:  moment(date).set("hour", 7).set("minute", 0).set("second", 0),
      dateTimeClose: moment(date).set("hour", 23).set("minute", 0).set("second", 0),
    })
  }, [tourId]);


  const getAllTour = () => {
    if(filterOnChange) {      
      locationTourApi.getAll({'ads': true}).then((res) => {
        setListLocationTour(res.data);
      });
    }else{
      locationTourApi.getAll().then((res) => {
        setListLocationTour(res.data);
      });
    }
    
  };

  const fillDataToForm = (id) => {
    if (id){
    locationTourApi.getById(id,language).then((res) => {
      const pictureFilenameParse = JSON.parse(res.data.pictureFilename);
      setDataLocationTour({
        ...res.data,
        pictureFilename: JSON.parse(res.data.pictureFilename),
      });
      const files = [];
      const filesSubmit = [];
      if (pictureFilenameParse.length > 0) {
        pictureFilenameParse.forEach((item) => {
          files.push({ url: BASE_IMAGE_URL + item });
          filesSubmit.push(item);
        });
      }
      setFileList(files);
      setFileListSubmit(filesSubmit);
      setTourData(res.data);
      setDesData(res.data.description);
      setTitleData(res.data.title);
      setCenterMap({
        lng: res.data.longitude,
        lat: res.data.latitude,
      });
      setOnRegisterAds(res.data.isShowAds  ?? false)
      setIsShowAds(res.data.isShowAds  ?? false)
      setIsCustomerAds(res.data.isCustomer ?? false)
      form.setFieldsValue({
        title: res.data.title,
        countryId: res.data.countryId,
        provinceId: res.data.provinceId,
        province: res.data.province,
        address: res.data.address,
        phone: res.data.phone,
        longitude: res.data.longitude,
        latitude: res.data.latitude,
        description: res.data.description,
        unitPrice: res.data.unitPrice,
        
        isAdsTripZe: res.data.isCustomer == true ?  false : res.data.isShowAds,
        isShowAds: res.data.isShowAds,
        isCustomer: res.data.isCustomer,

        dateTimeClose: res.data.dateTimeClose!=null ? moment(res.data.dateTimeClose):null,
        dateTimeOpen: res.data.dateTimeOpen!=null ? moment(res.data.dateTimeOpen):null,
      });

    });
    }
  }

  const openModalTour = (id) => {
    setIsShowUpdateTour(true);
    setTourId(id);
    getCountry();
    fillDataToForm(id)    
  };
  const onCloseModalTour = () => {
    setTourId(0)
    setIsShowUpdateTour(false);
    setLanguage("vi");
    setCenterMap('')
    setFileList([]);
    setFileListSubmit([]);
    setOnRegisterAds(false)
    form.setFieldsValue({
      title: "",
      countryId: 0,
      provinceId: 0,
      province: "",
      address: "",
      longitude: "",
      latitude: "",
      description: "",
      phone: "",
      isAdsTripZe: false,
      isShowAds: false,
      isCustomer: false,
      sendNotification: false,
    });
    setIsCustomerAds(false)
    setIsShowAds(false)
  };

  const onLocationChange = (location) => {
    setDataChange(true)
    form.setFieldsValue({
      latitude:location.lat,
      longitude:location.lng,
    });
  }

  const deleteTour = () => {
    locationTourApi.deleteLocationTourById(tourId).then((res) => {
      notification.success({ message: `Xóa Thành Công` });
      getAllTour();
      setOpenDeleteDialog(false);
      setTourId(0)
    });
  };

  const getCountry = () => {
    countriesApi.getAll().then((response) => {
      setListCountry(response.data);
      form.setFieldsValue({ countryId: response.data[0].id });
      onSelectCountry(response.data[0]?.id)
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, placeHolderSearch) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Tìm kiếm ${placeHolderSearch}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Tìm kiếm
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Đặt lại
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Lọc
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
     get(record, dataIndex)
    .toString()
    .toLowerCase()
    .includes(value.toLowerCase()),
      // record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      // searchedColumn === dataIndex ? (
        isEqual(searchedColumn, dataIndex) ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const columnsTour = [
    {
      title: "Tiêu đề",
      dataIndex: "title",
      key: "title",
      ...getColumnSearchProps("title" , "tiêu đề"),
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
      ...getColumnSearchProps("address", "địa chỉ"),
    },
    {
      title: "Tỉnh Thành",
      dataIndex: "provinceName",
      key: "provinceName",
      ...getColumnSearchProps("provinceName", "Tỉnh Thành"),
    },
    // {
    //   title: "Quốc Gia",
    //   dataIndex: "countryName",
    //   key: "countryName",
    //   ...getColumnSearchProps("countryName"),
    // },
    // {
    //   title: "Mô Tả",
    //   dataIndex: "description",
    //   key: "description",
    //   ...getColumnSearchProps("description"),
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalTour(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteTour(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];
  const openDeleteTour = (id) => {
    setTourId(id);
    setOpenDeleteDialog(true);
  };
  const onChangeTitle = (value) => {
    setTitleData(value.target.value);
  };
  const onChangeDes = (value) => {
    setDesData(value.target.value);
  };

  const onHandleTranslate = (id, forceLang) => {
    setLoadingTranslate(true);
    const textData = {
      title: titleData,
      description: desData,
    };
    const data = {
      text: textData,
      language: forceLang ? forceLang:language,
      type: "tour",
      id: id,
    };
    translateApi.translate(data).then((res) => {
      const textTranslate = res.data
      console.log('textTranslate', textTranslate);
      if (textTranslate.length > 0) {
        setLoadingTranslate(false);
        const newdata = []
        textTranslate.map((e) => {
          if (e.language == language) {
            form.setFieldsValue({
              title: e.title,
              description: e.description,
            });
          }
        })
        console.log('newdata', newdata);
      } else {
        setLoadingTranslate(false);
        setDataTranslate(dataTranslate);
        let newFormData = {
          title: res.data.title,
          description: res.data.description,
        }
        setDataChange(false)
        if (!deepEqual(newFormData, lastData[data.language])){
          setDataChange(true)
        }
        form.setFieldsValue({
          title: res.data.title,
          description: res.data.description,
        });
      }

    });
  };

  const onFinishHandleTour = (values) => {
    values.pictureFilename = fileListSubmit;
    console.log(values);    
    values.isShowAds = values.isAdsTripZe == true ? true : values.isShowAds
    values.isCustomer = isCustomer    
    values.userId = adminService.AuthService.getCurrentUser().id
    const stringData = JSON.stringify(values);
    if (tourId !== 0) {
      if (language === "vi") {
        locationTourApi.updateLocationTour(tourId, values).then((res) => {
          notification.success({ message: "Cập nhật Địa Điểm Du Lịch thành công" });
          form.setFieldsValue({
            latitude: values.latitude,
            longitude: values.longitude,
          });
          let newData = {}
          newData[language] = {}
          newData[language].title = form.getFieldValue("title")
          newData[language].description = form.getFieldValue("description")
          setLastData(newData)
          setDataChange(false)
          getAllTour();          
        });
      } else {
        var temp={}
         temp[language] =
          {
            title: values.title,
            description: values.description,
          }
        
        // const temp={
        //   'en':{
        //     title: values.title,
        //     description: values.description,
        //   }
        // }
        const data = { 
          textTranslate: JSON.stringify(temp),
          userId: adminService.AuthService.getCurrentUser().id
        };
        locationTourApi.updateLocationTour(tourId, data).then((res) => {
          notification.success({ message: "Cập nhật Địa Điểm Du Lịch thành công" });
          let newData = {}
          newData[language] = {}
          newData[language].title = form.getFieldValue("title")
          newData[language].description = form.getFieldValue("description")
          setLastData(newData)
          setDataChange(false)
          getAllTour();
        });
      }
    } else {
      locationTourApi.createLocationTour(values).then((res) => {
        notification.success({ message: "Tạo Địa Điểm Du Lịch thành công" });
        onCloseModalTour();
        getAllTour();
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined  /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Thêm ảnh
      </div>
    </div>
  );

  const handleChange = async ({ fileList: newFileList }) => {
    if (!invalidImage) {
      onFormValueChange()
      setFileList(newFileList);
      const urlArray = [];
      const urlArraySubmit = [];
      let checkTotal = 0;
      let check = 0;
      await newFileList.forEach((item) => {
        if (typeof item?.status !== "undefined") {
          checkTotal++;
          if (item.status === "uploading") {
            setLoading(true);
            return;
          }
          if (item.status === "done") {
            check++;
          }
        } else {
          urlArray.push(item);
          urlArraySubmit.push("/images/" + item.url.split("/images/")[1]);
        }
      });
      if (check === checkTotal) {
        newFileList.forEach((item) => {
          if (typeof item?.status !== "undefined") {
            const temp = { url: BASE_IMAGE_URL + item.response.data.url };
            urlArray.push(temp);
            urlArraySubmit.push(item.response.data.url);
          }
        });
      }
      setFileListSubmit(urlArraySubmit);
      setLoading(false);
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      setInvalidImage(true);
    } else {
      setInvalidImage(false);
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    return isJpgOrPng;
  };

  const [textSearch, setTextSearch] = useState("");
  const [timer, setTimer] = useState(null);

  // form.setFieldsValue(
  //   {
  //     latitude:
  //       currentLocation?.latitude != ""
  //         ? currentLocation?.latitude
  //         : tourData?.latitude,
  //     longitude:
  //       currentLocation?.longitude != ""
  //         ? currentLocation?.longitude
  //         : tourData?.longitude,
  //   },
  //   []
  // );

  const onSearch = (e) => {
    setTextSearch(e.target.value);
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      locationTourApi.getAll({ title: textSearch }).then((res) => {
        setListLocationTour(res.data);
      });
    }, 1000);
    setTimer(newTimer);
  };
  
  const onFormValueChange = () =>{
    setDataChange(true)
  }

  const onSelectLanguage = async (value) => {
    onHandleTranslate(tourId, value)
    setDataChange(true)
    setLanguage(value);
  };

  const onRegisterAdsChange = (value) => {
    setOnRegisterAds(!onRegisterAds)
    form.setFieldsValue({isCustomer: false, isAdsTripZe: true})
    setIsShowAds(false)
    setIsCustomerAds(false)
  };
  const onSendNotificationChange = (value) => {
    setSendNotification(!sendNotification)
    form.setFieldsValue({sendNotification: !sendNotification})
  };

  const onChangeShowAds = () => {
    form.setFieldsValue({isCustomer: false})
    setIsShowAds(true)
    setIsCustomerAds(false)
    setDataChange(true)
  }

  const onChangeShowCustomerAds = () => {
    form.setFieldsValue({isAdsTripZe: false})
    setIsCustomerAds(true)
    setIsShowAds(false)
    setDataChange(true)
  }

  const onSelectCountry = async (value) => {
    await countriesApi.getById(value).then((res) => {
      setProvince(res.data.province);
      form.setFieldsValue({
        province: "",
      });
    });
  };

  const onSelectProvince = async (value, key) => {
    province.forEach((element) => {
      if ((element.id == key.key)) {
        setCenterMap({
          lng: element.longitude,
          lat: element.latitude,
        });
      }
    });
  };

  const onChangeFilter = (e) => {
    // setAllChecked(false)
    // setSelectedRowKeys([])
    setFilterOnChange(!filterOnChange);    
   }

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Địa Điểm Du Lịch
          </Typography>
        }
        extra={
          <Space>
            <Checkbox  value={1} onChange={onChangeFilter} >Dữ liệu quảng cáo</Checkbox>             
            {/* <Search
              size="large"
              onChange={onSearch}
              placeholder="Tìm kiếm"
              value={textSearch}ß
            // onPressEnter={(e) => { onSearch() }}
            /> */}

            <Button
              type="primary"
              style={{
                borderRadius: "8px",
              }}
              onClick={() => {
                setIsShowUpdateTour(true);
                getCountry();
              }}
            >
              Tạo Địa Điểm Du Lịch
            </Button>
          </Space>
        }
      >
        <Table columns={columnsTour} dataSource={listLocationTour} bordered />
        <Modal
          title={tourId !== 0 ? "Cập nhật Địa Điểm Du Lịch" : "Tạo Địa Điểm Du Lịch"}
          visible={isShowUpdateTour}
          onCancel={() => {
            onCloseModalTour();
            setTourId(0);
            setFileList([]);
            form.setFieldsValue({ title: "" });
            setLanguage("vi");
          }}
          width="80%"
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalTour();
                }}
              >
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
                disabled = {!dataChange}
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Row justify="space-around">
            <Col span={12}>{tourId !== 0&&
              <Row justify="end">
                <Select
                  onChange={onSelectLanguage}
                  defaultValue="vi"
                  value={language}
                >
                  <Option value="vi">Tiếng Việt</Option>
                  <Option value="en">English</Option>
                  <Option value="fr">French</Option>
                  <Option value="zh-CN">Chinese</Option>
                  <Option value="ko">Korean</Option>
                  <Option value="de">German</Option>
                </Select>
                <Button
                  type="primary"
                  onClick={() => {
                    onHandleTranslate(tourId);
                  }}
                  loading={loadingTranslate}
                >
                  Dịch
                </Button>
              </Row>}
              <Upload
                name="file"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={true}
                multiple={true}
                action={BASE_IMAGE_URL + "/api/upload"}
                beforeUpload={beforeUpload}
                onChange={handleChange}
                fileList={fileList}
                disabled={ language!='vi' }
              >
                {uploadButton}
              </Upload>
              {/* //// */}
              <Form
                {...layout}
                form={form}
                name="CU-tour"
                onFinish={onFinishHandleTour}
                onValuesChange = {onFormValueChange}
              >
                <Form.Item
                  name="title"
                  label="Tên"
                  rules={[{ required: true }]}
                >
                  <Input size="large" onChange={onChangeTitle} />
                </Form.Item>
                <Form.Item
                  name="countryId"
                  label="Quốc Gia"
                // rules={[{ required: true }]}
                >
                  <Select onChange={onSelectCountry} disabled={ language!='vi' }>
                    {listCountry?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.countryName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="provinceId" label="Tỉnh Thành">
                  <Select onChange={onSelectProvince} disabled={ language!='vi' }>
                    {province?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="address" label="Địa Chỉ">
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>
                <Form.Item name="phone" label="Số điện thoại">
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>                
                <Form.Item name="dateTimeOpen" label="Giờ mở cửa">
                  {/* <Input /> */}
                  <DatePicker
                    format="HH:mm:ss" disabled={ language!='vi' }
                    showTime={{ defaultValue: moment("00:00:00", "HH:mm:ss") }}
                  />
                </Form.Item>
                <Form.Item name="dateTimeClose" label="Giờ đóng cửa">
                  {/* <Input /> */}
                  <DatePicker
                    format="HH:mm:ss" disabled={ language!='vi' }
                    showTime={{ defaultValue: moment("00:00:00", "HH:mm:ss") }}
                  />
                </Form.Item>
                <Form.Item
                  name="unitPrice"
                  label="Giá vé (VNĐ)"
                >
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>

                <Form.Item
                  name="latitude"
                  label="Latitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" disabled={ language!='vi' } />
                </Form.Item>
                <Form.Item
                  name="longitude"
                  label="Longitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>

                <Form.Item name="description" label="Mô Tả">
                  <Input.TextArea rows={15} onChange={onChangeDes} />
                </Form.Item>                
                <Form.Item label="Quảng cáo" name="isShowAds" valuePropName="checked">
                    <Checkbox  disabled={ language!='vi' } onChange={onRegisterAdsChange}/>                                                  
                 </Form.Item>

                {onRegisterAds ?<Form.Item label="TripZe" name="isAdsTripZe" valuePropName="checked">
                    <Radio value={'isAdsTripZe'} disabled={ language!='vi' } onChange={onChangeShowAds}/>                                                  
                 </Form.Item> : null}

                 {onRegisterAds ? <Form.Item label="Đối tác" name="isCustomer" valuePropName="checked">
                    <Radio value={'isCustomer'} disabled={ language!='vi' } onChange={onChangeShowCustomerAds}/>                                                  
                 </Form.Item> : null }

                     {/* {onRegisterAds ? <div>
                      <Radio.Group name={'rb1'} onChange={() => {
                        
                      }}>
                      <Row justify="space-between">
                          <Radio value={'isShowAds'} onChange={onChangeShowAds} >TripZe</Radio>
                      
                          <Radio  value={'isCustomer'} onChange={onChangeShowCustomerAds} >Đối tác</Radio> 
                      </Row>  
                      </Radio.Group>
                      </div> 
                        : null } */}

                {/* <Form.Item name="isShowAds" label="TripZe" valuePropName="checked" >
                    <Checkbox  disabled={ language!='vi' }/>
                </Form.Item>
                <Form.Item name="isCustomer" label="Khách hàng" valuePropName="checked" >
                    <Checkbox   disabled={ language!='vi' }/>
                </Form.Item> */}
                <Form.Item label="Gửi thông báo" name="sendNotification" valuePropName="checked">
                    <Checkbox  disabled={ language!='vi' } onChange={onSendNotificationChange}/>                                                  
                 </Form.Item>
              </Form>
            </Col>
            <Col span={10}>
              <MapManagement location={centerMap} onChange = {onLocationChange} />
            </Col>
          
          </Row>
         
          {/* //// */}
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteTour}
        onCancel={() => {
          setTourId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa địa điểm du lịch`}
      >
        Bán có chắc muốn xóa địa điểm du lịch này?
      </Modal>
    </>
  );
}
